import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ListItem } from '../../core/models/list-item';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SearchCriteria } from '../models/search-criteria';

@Component({
  selector: 'irar-advanced-search-form',
  template: `
  <form (ngSubmit)="searchDocuments()" [formGroup]="form">
  <table width="100%" border="0" cellpadding="5" cellspacing="0">
    <tr>
      <td colspan="3">
        <img src="../images/spacer.gif" height="10" width="1" alt="" border="0" />
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <b>FARM NAME</b>
      </td>
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td valign="top">
        <select formControlName="farm" multiple size="3">
          <option *ngFor="let f of farms" [value]="f.title">{{f.title}}</option>
        </select>
      </td>
      <td valign="top" style="padding:5px 20px;">Each farm encompasses one or more sites. To view a map of farms and their related sites, click
        <a routerLink="/mapsearch">here</a>.
      </td>
      <td valign="top">If you're looking for a document that doesn't pertain to a particular Site, select "BARC-Wide" under Site Name selection.
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <b>SITE NAME</b>
      </td>
      <td>&nbsp;</td>
    </tr>
    <tr>
      <td colspan="2" valign="top">
        <select formControlName="site" multiple size="6">
        <option *ngFor="let s of sites" [value]="s.abbreviation">{{s.abbreviation}} ({{s.title}})</option>
        </select>
      </td>
      <td valign="top">In instances where a site has a more common name, that name is displayed next to the technical name.</td>
    </tr>
    <tr>
      <td colspan="3">
        <table>
          <tr>
            <td><b>KEYWORD SEARCH</b></td>
            <td colspan="5"><input formControlName="title" size="40" maxlength="50" value="" /></td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td colspan="3">
        <table>
          <tr>
            <td><b>DATE</b></td>
            <td>
              <select style="width:75px;padding:1px 0 2px 0;" formControlName="startMonth" placeholder="Month">
                <option disabled [value]="null">Month</option>
                <option value="0">January</option>
                <option value="1">February</option>
                <option value="2">March</option>
                <option value="3">April</option>
                <option value="4">May</option>
                <option value="5">June</option>
                <option value="6">July</option>
                <option value="7">August</option>
                <option value="8">September</option>
                <option value="9">October</option>
                <option value="10">November</option>
                <option value="11">December</option>
              </select>
            </td>
            <td>
              <input type="number" formControlName="startYear" style="width:50px;" placeholder="YYYY"/>
            </td>
            <td><b>TO</b></td>
            <td>
              <select style="width:75px;padding:1px 0 2px 0;" formControlName="endMonth" placeholder="Month">
                <option disabled [value]="null">Month</option>
                <option value="0">January</option>
                <option value="1">February</option>
                <option value="2">March</option>
                <option value="3">April</option>
                <option value="4">May</option>
                <option value="5">June</option>
                <option value="6">July</option>
                <option value="7">August</option>
                <option value="8">September</option>
                <option value="9">October</option>
                <option value="10">November</option>
                <option value="11">December</option>
              </select>
            </td>
            <td>
              <input type="number" formControlName="endYear" style="width:50px;" placeholder="YYYY"/>
            </td>
          </tr>
        </table>
      </td>
      <td valign="top"></td>
    </tr>
    <tr>
      <td colspan="2" align="right">
        <input id="submit" type="submit" value="Search" /> &nbsp;&nbsp;&nbsp;
        <input id="reset" type="button" value="Clear All" (click)="clearForm()" /></td>
      <td>&nbsp;</td>
    </tr>
  </table>
  </form>
  <p-dialog [modal]="true" [showHeader]="false" [(visible)]="searching">
    <div style="text-align:center">Searching...</div>
  </p-dialog>
  `
})
export class AdvancedSearchFormComponent {
  @Input() sites: ListItem[];
  @Input() farms: ListItem[];
  @Input() authors: string[];
  @Input() loggedIn: boolean;
  @Input() searching: boolean;
  @Output() search: EventEmitter<SearchCriteria> = new EventEmitter();

  form: FormGroup;
  years: string[];

  constructor(fb: FormBuilder) {
    this.years = [];
    for (var i = 2000; i <= new Date().getFullYear() + 2; i++) {
      this.years.push(i.toString());
    }
    this.form = fb.group({
      'farm': [null],
      'site': [null],
      'title': [null],
      'startMonth': [null],
      'startYear': [null],
      'endMonth': [null],
      'endYear': [null],
      'author': [null],
      'accessionNo': [null]
    });
  }

  searchDocuments() {
    let criteria: SearchCriteria = this.form.getRawValue();
    if (criteria.startMonth && criteria.startYear) {
      criteria.startDate = new Date(criteria.startYear, criteria.startMonth, 1);
    } else if (criteria.startYear && !criteria.startMonth) {
      criteria.startDate = new Date(criteria.startYear, 0, 1);
    }
    if (criteria.endMonth && criteria.endYear) {
      let dt = new Date(criteria.endYear, criteria.endMonth, 1)
      dt.setMonth(dt.getMonth() + 1);
      dt.setDate(dt.getDate() - 1);
      criteria.endDate = dt;
    } else if (criteria.endYear && !criteria.endMonth) {
      let dt = new Date(criteria.endYear, 11, 1)
      dt.setMonth(dt.getMonth() + 1);
      dt.setDate(dt.getDate() - 1);
      criteria.endDate = dt;
    }
    if (criteria.endDate < criteria.startDate) {
      let temp = criteria.startDate;
      criteria.startDate = criteria.endDate;
      criteria.endDate = temp;
      criteria.startDate.setDate(1);
      criteria.startDate.setMonth(1);
      criteria.endDate.setMonth(criteria.endDate.getMonth() + 1);
      criteria.endDate.setDate(criteria.endDate.getDate() - 1);
    }
    this.search.emit(criteria);
  }

  clearForm() {
    this.form.reset();
  }
 }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/advanced-search-form.ts